import React, { useEffect, useState } from "react";
import { Fab, Paper } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import ChatWindow from "./ChatWindow";
import { createConversation, getLatestConversation } from "../../services/chatApi";

const THEME_ORANGE = "#F07828";

const GlobalChatbotWidget = () => {
  const [open, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState(null);

  const loadLatestConversation = async () => {
    try {
      const res = await getLatestConversation();
      setConversationId(res.conversationId);
    } catch (err) {
      console.error("Failed to load latest conversation:", err);
    }
  };

  const handleToggle = async () => {
    const nextOpen = !open;
    setOpen(nextOpen);

    if (nextOpen) {
      await loadLatestConversation();
    }
  };

  const handleNewChat = async () => {
    try {
      const res = await createConversation();
      setConversationId(res.conversationId);
    } catch (err) {
      console.error("Failed to start new chat:", err);
    }
  };

  useEffect(() => {
    if (open) {
      loadLatestConversation();
    }
  }, [open]);

  return (
    <>
      <Fab
        onClick={handleToggle}
        sx={{
          position: "fixed",
          right: 24,
          bottom: 24,
          zIndex: 1400,
          bgcolor: THEME_ORANGE,
          color: "#fff",
          "&:hover": { bgcolor: THEME_ORANGE },
        }}
      >
        {open ? <CloseIcon /> : <ChatIcon />}
      </Fab>

      {open && conversationId && (
        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            right: 24,
            bottom: 90,
            width: 420,
            maxWidth: "calc(100vw - 24px)",
            height: 620,
            zIndex: 1400,
            borderRadius: 3,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ChatWindow
            conversationId={conversationId}
            onNewChat={handleNewChat}
          />
        </Paper>
      )}
    </>
  );
};

export default GlobalChatbotWidget;